import {
  SparkleIcon,
  GiftIcon,
  StarIcon,
  HeartIcon,
  BellIcon,
  TagIcon,
  TrendUpIcon,
  ShoppingCartIcon,
  PackageIcon,
  TruckIcon,
  MapPinIcon,
  InfoIcon,
  WarningIcon,
  CheckCircleIcon,
} from '@phosphor-icons/react';

export const phosphorIcons = {
  SparkleIcon,
  GiftIcon,
  StarIcon,
  HeartIcon,
  BellIcon,
  TagIcon,
  TrendUpIcon,
  ShoppingCartIcon,
  PackageIcon,
  TruckIcon,
  MapPinIcon,
  InfoIcon,
  WarningIcon,
  CheckCircleIcon,
};

export const phosphorIconNames = Object.keys(phosphorIcons);
